;(function () {
  'use strict'

  angular
    .module('pub.bundle.service', [])
    .factory('BundleService', BundleService)
    .service('BundleCache', BundleCache)

  /** @ngInject */
  function BundleService($http, $q, API) {
    function getSetId(parentId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/sets/' + parentId + '/bundles').success(defered.resolve)

      return defered.promise
    }

    function getChannelId(parentId) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/channels/' + parentId + '/bundles')
        .success(defered.resolve)

      return defered.promise
    }

    function get(parentId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/sets/' + parentId + '/bundles').success(defered.resolve)

      return defered.promise
    }

    function getId(parentId, id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/sets/' + parentId + '/bundles/' + id)
        .success(defered.resolve)

      return defered.promise
    }

    function adminGetId(parentId, id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/sets/' + parentId + '/bundles/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(parentId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/bundles', model)
        .success(defered.resolve)

      return defered.promise
    }

    function saveChannel(parentId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + parentId + '/bundles', model)
        .success(defered.resolve)

      return defered.promise
    }

    function update(parentId, id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/bundles/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateBundle(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/bundles/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function clone(id, model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/bundles/' + id + '/clone', model).success(defered.resolve)

      return defered.promise
    }

    function prime(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id + '/prime')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listBundleSegmentation(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/bundles/' + id + '/user_segments').success(defered.resolve)

      return defered.promise
    }

    function listBundleSegmentationUsers(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/bundles/' + id + '/user_segmenter_users')
        .success(defered.resolve)

      return defered.promise
    }

    function listSegmentation() {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/user_segments').success(defered.resolve)

      return defered.promise
    }

    function addBundleSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeBundleSegmentation(id, segmentId) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/bundles/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)

      return defered.promise
    }

    function listProducts(parentId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'admin/products/dp').success(defered.resolve)

      return defered.promise
    }

    function listProductsPublished() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/products/dp/published')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function reorder(parentId, id, order) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/sets/' + parentId + '/bundles/' + id + '/order/' + order)
        .success(defered.resolve)

      return defered.promise
    }

    function listTranslations(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/bundles/' + id + '/bundle_translations')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getBundleStockStats(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/bundles/' + id + '/stock/stats')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function getTranslation(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/bundle_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createTranslation(id, model) {
      var defered = $q.defer()

      $http
        .post(
          API.API_URL + 'publisher/bundles/' + id + '/bundle_translations?automatic=true',
          model,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateTranslation(id, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/bundle_translations/' + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeTranslation(id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/bundle_translations/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function createFlashPack(id, oft, ofd, ofs, usid, mkt) {
      var defered = $q.defer()

      $http
        .post(
          API.API_URL +
            'admin/bundles/' +
            id +
            '/flash_packs?oft=' +
            oft +
            '&ofd=' +
            ofd +
            '&ofs=' +
            ofs +
            '&usid=' +
            usid +
            '&mkt=' +
            mkt,
        )
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function configureBountyShinyOdds(id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/bundles/' + id + '/bounty_shiny_odds', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      get: get,
      getSetId: getSetId,
      getChannelId: getChannelId,
      save: save,
      saveChannel: saveChannel,
      update: update,
      getId: getId,
      adminGetId: adminGetId,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      clone: clone,
      prime: prime,
      listSegmentation: listSegmentation,
      listBundleSegmentation: listBundleSegmentation,
      listBundleSegmentationUsers: listBundleSegmentationUsers,
      addBundleSegmentation: addBundleSegmentation,
      removeBundleSegmentation: removeBundleSegmentation,
      listProducts: listProducts,
      reorder: reorder,
      listTranslations: listTranslations,
      getTranslation: getTranslation,
      createTranslation: createTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation,
      listProductsPublished: listProductsPublished,
      createFlashPack: createFlashPack,
      getBundleStockStats: getBundleStockStats,
      configureBountyShinyOdds: configureBountyShinyOdds,
      updateBundle,
    }
  }

  /** @ngInject */
  function BundleCache() {
    this.odds = []
    this.oddsOtherSets = []
    this.oddsOtherChannels = []
    this.odds_step3 = []
    this.odds_step4 = []
    this.otherSets_step3 = []
    this.otherChannel_step4 = []

    this.addStep3 = function (odds, otherSets) {
      this.odds_step3 = odds
      this.otherSets_step3 = otherSets
    }

    this.addStep4 = function (odds, otherChannels) {
      this.odds_step4 = odds
      this.otherChannel_step4 = otherChannels
    }

    this.getStep3 = function () {
      return [this.odds_step3, this.otherSets_step3]
    }

    this.getStep4 = function () {
      return [this.odds_step4, this.otherChannel_step4]
    }

    this.clear = function () {
      this.odds = []
      this.oddsOtherSets = []
      this.oddsOtherChannels = []
    }

    this.getOdds = function () {
      return this.odds
    }

    this.getOddsOtherSets = function () {
      return this.oddsOtherSets
    }

    this.getOddsOtherChannels = function () {
      return this.oddsOtherChannels
    }

    this.addOdds = function (item) {
      this.odds = item
    }

    this.addOddsOtherSets = function (item, all) {
      if (item.length === 0) {
        return
      }
      if (all !== undefined) {
        this.oddsOtherSets = item
      } else {
        this.oddsOtherSets.push(item)
      }
    }

    this.addOddsOtherChannels = function (item, all) {
      if (item.length === 0) {
        return
      }
      if (all !== undefined) {
        this.oddsOtherChannels = item
      } else {
        this.oddsOtherChannels.push(item)
      }
    }

    this.removeOddsOtherSets = function (item) {
      if (item.length === 0) {
        return
      }

      if (this.oddsOtherSets.length === 0) {
        this.oddsOtherSets = []
      }

      for (var i = 0; i < this.oddsOtherSets.length; i++) {
        if (this.oddsOtherSets[i].id === item.id) {
          if (this.oddsOtherSets[i].q.length === 0) {
            this.oddsOtherSets.remove(this.oddsOtherSets[i])
            i > 0 ? (i -= 1) : (i = 0)
          } else {
            this.oddsOtherSets[i] = item
          }
        }
      }
    }

    this.removeOddsOtherChannels = function (item) {
      if (item.length === 0) {
        return
      }

      if (this.oddsOtherChannels.length === 0) {
        this.oddsOtherChannels = []
      }

      for (var i = 0; i < this.oddsOtherChannels.length; i++) {
        if (this.oddsOtherChannels[i].id === item.id) {
          if (this.oddsOtherChannels[i].q.length === 0) {
            this.oddsOtherChannels.remove(this.oddsOtherChannels[i])
            i > 0 ? (i -= 1) : (i = 0)
          } else {
            this.oddsOtherChannels[i] = item
          }
        }
      }
    }
  }
})()
